import * as z from 'zod';

// export const awardQueryLinkerSchemaWithExData = z.object({
//   id: z.number(),
//   name: z
//     .string()
//     .refine((val) => z.string().toLowerCase().email().safeParse(`a@${val}`).success, 'Invalid award name'),
//   dns_management: z.string().nullable(),
//   deployment_path: z.string().nullable(),
// });

// export type AwardQueryLinkerSchemaWithExData = z.infer<typeof awardQueryLinkerSchemaWithExData>;

export const awardQueryLinkerSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export type AwardQueryLinkerSchema = z.infer<typeof awardQueryLinkerSchema>;
